
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String
    },
    label: {
      type: String
    },
    validateAs: {
      type: String
    },
    mask: {
      type: String
    },
    noDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      success: false
    }
  },
  computed: {},
  mounted() {
    this.$emit('validation', this.validate(this.value) === true)
  },
  watch: {},
  methods: {
    upd(v) {
      this.$emit('validation', this.validate(v) === true)
      this.$emit('input', v)
    },
    validate(v) {
      let error = ''
      let res = true

      if (!v && this.validateAs) return ''

      if (this.validateAs === 'email') {
        res = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v)
        error = ''
      } else if (this.validateAs === 'required') {
        res = !!v
        error = ''
      } else if (this.validateAs === 'first_last_name') {
        res = v.length >= 3 && /\b\w+\b\s+\b\w+\b/.test(v)
        error = 'Please enter the first and last name'
      } else if (this.validateAs === 'date') {
        res = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(20[2-4][0-9]|[2-4][0-9])$/.test(v);
        error = ''
      } else if (this.validateAs === 'phone') {
        res = /^\+1 \(\d{3}\) \d{3}-\d{4}$/.test(v);
        error = ''
      } else {
        // neither fail nor success
        this.success = false
        return true
      }

      this.success = res
      return res || error
    }
  }
}
